import { render, staticRenderFns } from "./JSelectZyz.vue?vue&type=template&id=2966082a&scoped=true"
import script from "./JSelectZyz.vue?vue&type=script&lang=js"
export * from "./JSelectZyz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2966082a",
  null
  
)

export default component.exports